import { Navigate } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_SERIES_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const MobileCommonPacksPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_SERIES_MARKET, {
        sport: Sport.FOOTBALL,
      })}
    />
  );
};

export default MobileCommonPacksPage;
